import { gate } from 'hub-http/gates';
import { userInfoSync } from 'hub-http/userInfo';
import { useMemo } from 'react';
export const GATE_DEFINITIONS = {
  workflowTemplatesPhase2: gate('Marketplace::WorkflowTemplates::Phase2'),
  workflowsModernEditor: gate('Workflows:ModernEditor'),
  breezeBuilder: gate('DpgDevexAgents:BuilderWorker')
};
function getGates() {
  try {
    return userInfoSync().gates;
  } catch (_unused) {
    return [];
  }
}
export function useGates() {
  const gates = getGates();
  return useMemo(() => Object.fromEntries(Object.entries(GATE_DEFINITIONS).map(([k, g]) => [k, gates.includes(g)])), [gates]);
}